import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ExamGroupService = sdk.getService('ExamGroupService');

export const useExamGroupsById = (examGroupIds: string[]) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['exam-groups', examGroupIds],
    queryFn: () => ExamGroupService.getExamGroupsByIds(examGroupIds),
    enabled: !!examGroupIds.length
  });

  return {
    examGroups: data,
    isLoading,
    error
  };
};
